import { createFileRoute } from '@tanstack/react-router';

import { BillingSettings } from '@/features/billing/components/billing-settings';

export const Route = createFileRoute(
  '/_authenticated/$tenantId/settings/billing',
)({
  component: BillingSettings,
});
